import pickBy from 'lodash/pickBy'

import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import { useSessionMetadataOrFail } from '@/hooks/useSessionMetadataOrFail'
import {
  selectIcaewModals,
  setNumStepsCompleted,
} from '@/redux/slices/icaewModals'

export function useIcaewModals() {
  const numStepsCompleted = useAppSelector(selectIcaewModals).numStepsCompleted
  const dispatch = useAppDispatch()
  const icaewModals = pickBy(
    useSessionMetadataOrFail().icaewModals || {},
    (value) => typeof value === 'boolean',
  )

  const numSteps = Object.keys(icaewModals).length
  const numIncompleteSteps = Object.values(icaewModals).filter(
    (shouldShow) => shouldShow,
  ).length
  const currentStepNumber = numStepsCompleted + 1

  const shouldShowStepIndicators =
    currentStepNumber < numIncompleteSteps || numStepsCompleted > 0

  function recordStepCompletion() {
    dispatch(setNumStepsCompleted(numStepsCompleted + 1))
  }

  return {
    numSteps,
    currentStepNumber,
    shouldShowStepIndicators,
    recordStepCompletion,
  }
}
